import React from 'react'
import cn from 'classnames'
import { Bitcoin, DollarSign } from 'lucide-react'
import api from 'api/api'
import { SATOSHI_UNIT, USD_UNIT, type BsvUnit } from 'lib/bsv-util'
import useStore from 'state/knovStore'
import styles from './bsv-usd-switch.module.scss'

export default function BsvUsdSwitch() {
    const bsvUnit = useStore(state => state.bsvUnit)
    const useUsd = bsvUnit === USD_UNIT

    const handleUnitChange = (unit: BsvUnit) => {
        if (unit === bsvUnit || (unit === SATOSHI_UNIT && !useUsd)) return

        useStore.setState({ bsvUnit: unit })
        void api.updateUserSpaceOptions({ bsvUnit: unit }).catch(error => {
            console.error('Failed to persist display currency', error)
        })
    }

    return (
        <div className={styles.switch} role="group" aria-label="Display currency">
            <button
                type="button"
                className={cn(styles.unitButton, styles.bsvButton, !useUsd && styles.active)}
                aria-label="Display amounts in BSV"
                aria-pressed={!useUsd}
                onClick={() => handleUnitChange(SATOSHI_UNIT)}
            >
                <Bitcoin className={styles.bsvIcon} aria-hidden />
            </button>
            <button
                type="button"
                className={cn(styles.unitButton, styles.usdButton, useUsd && styles.active)}
                aria-label="Display amounts in USD"
                aria-pressed={useUsd}
                onClick={() => handleUnitChange(USD_UNIT)}
            >
                <DollarSign aria-hidden />
            </button>
        </div>
    )
}
